<script setup>
defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: validatorVariants,
  },
  size: {
    type: String,
    default: 'md',
    validator: validatorSizes,
  },
})
</script>

<template>
  <div
    class="d-badge bg-variants inline-flex items-center rounded-md font-bold text-white"
    :class="[variant, size]"
  >
    <slot />
  </div>
</template>

<style>
@reference '@/assets/style/index.css';

.d-badge {
  &.sm {
    @apply px-4 py-1 text-sm;
  }
  &.md {
    @apply px-6 py-2 text-base;
  }
  &.lg {
    @apply px-10 py-4 text-lg;
  }
}
</style>
